<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                    <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <div class="mt-2 text-center">
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                        Confirm Email Address
                    </h3>
                    <div class="mt-3 text-left">
                        <p class="text-sm text-gray-500 mb-2">
                            Please enter your e-mail address so we may send you payment reminders and other applicable notices.<br />
                            By clicking "I Agree" you are hereby authorizing {{ $parent.consumerPortalName }} to send correspondence to this e-mail address.
                        </p>

                        <input v-model="form.email" type="text" name="email" :id="`${unique}_email`" :class="`mb-4 py-3 px-4 rounded bg-gray-100 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-none rounded-bl-md bg-transparent focus:z-10 sm:text-sm border-gray-300`" placeholder="Your email">
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button @click="agree" type="button" :class="`w-full inline-flex text-black justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`">
                    I Agree
                </button>
                <button @click="disagree" type="button" :class="`mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:mt-0 sm:col-start-1 sm:text-sm`">
                    Not Interested
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['show', 'email'],

        created() {
            this.unique = Math.floor(Math.random() * 100);
        },

        data() {
            return {
                unique: null,
                form: { email: '' }
            }
        },

        watch: {
            show: {
                immediate: true,
                handler: function (show, oldShow) {
                    if (! show && oldShow) {
                        this.form.email = '';
                    } else if (show && ! oldShow) {
                        this.form.email = this.email;
                    }
                }
            }
        },

        methods: {
            /**
             * @return {void}
             */
            agree() {
                if (this.email !== this.form.email) {
                    alert('The email you entered does not match.');
                } else {
                    this.$emit('agree');
                }
            },

            /**
             * @return {void}
             */
            disagree() {
                this.$emit('close');
            }
        }
    }
</script>